(function () {
  "use strict";

  class ParallaxElement {
    constructor(el) {
      this.el = el;
      this.el.style.transformOrigin = "center center";
      var props = this.el.getAttribute("parallax").split(":");
      this.fromY = Number(props[0]);
      this.toY = Number(props[1]);
      this.distanceY = this.toY - this.fromY;
      this.onUpdate();
    }
    onUpdate() {
      var progress = this.el.getBoundingClientRect().y / window.innerHeight;
      if (this.fromY !== null && this.distanceY !== null) {
        this.el.style.transform =
          "translate3d(0px, " + (this.fromY + this.distanceY * progress) + "px, 0px)";
      }
    }
  }

  class ShowAtElement {
    constructor(el) {
      this.el = el;
      this.el.style.opacity = 0.3;
      this.el.style.transition = "opacity .6s, transform 2s";
      this.el.style.transform = "scale(.9)";
    }
    onUpdate() {
      var rect = this.el.getBoundingClientRect();
      var visible =
        rect.bottom >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (visible) {
        this.el.style.opacity = 1;
        this.el.style.transform = "scale(1)";
      } else {
        this.el.style.opacity = 0.3;
      }
    }
  }

  class FadeInElement {
    constructor(el) {
      this.el = el;
      var props = this.el.getAttribute("fade-in").split(":");
      this.showPercent = props[0];
      if (props[1]) {
        this.el.style.transitionDelay = props[1] + "s";
      }
      this.onUpdate();
    }
    onUpdate() {
      var box = this.el.getBoundingClientRect();
      var h = window.innerHeight;
      if (box.y + box.height > h * 0.05 && box.y < h * this.showPercent) {
        this.el.classList.add("show");
      } else {
        this.el.classList.remove("show");
      }
    }
  }

  class StrikeThroughList {
    constructor(el) {
      this.el = el;
      this.visible = false;
    }
    onUpdate() {
      var rect = this.el.getBoundingClientRect();
      var vis =
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (vis && !this.visible) {
        this.visible = true;
        this.el.classList.add("active");
      }
    }
  }

  class VideoElement {
    constructor(el) {
      this.el = el;
      this.el.style.opacity = 0.3;
      this.el.style.transition = "opacity 1s";
    }
    onUpdate() {
      var rect = this.el.getBoundingClientRect();
      var visible =
        rect.bottom >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (visible) {
        this.el.play();
        this.el.style.opacity = 1;
      } else {
        this.el.pause();
        this.el.style.opacity = 0.3;
      }
    }
  }

  class Carousel {
    constructor(el) {
      this.el = el;
      this.visible = false;
      var self = this;
      this.el.querySelectorAll("div[carousel-nav]>span").forEach(function (btn) {
        var idx = Array.prototype.indexOf.call(btn.parentElement.children, btn);
        btn.addEventListener("click", function () {
          self.setActive(idx);
        });
      });
    }
    onUpdate() {
      var rect = this.el.getBoundingClientRect();
      var vis =
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (vis && !this.visible) {
        this.visible = true;
      }
    }
    setActive(index) {
      this.el.querySelectorAll("div[carousel-slides]>div").forEach(function (slide) {
        var si = Array.prototype.indexOf.call(slide.parentElement.children, slide);
        if (si === index) {
          slide.classList.add("active");
          setTimeout(function () {
            slide.classList.add("in");
          }, 200);
        } else {
          slide.classList.remove("active");
          slide.classList.remove("in");
        }
      });
      this.el.querySelectorAll("div[carousel-nav]>span").forEach(function (btn) {
        var bi = Array.prototype.indexOf.call(btn.parentElement.children, btn);
        if (bi === index) {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      });
    }
  }

  class Section {
    constructor(el) {
      this.el = el;
      this.videoElements = [];
      this.showAtElements = [];
      this.fadeInElements = [];
      this.carousels = [];
      this.strikethroughLists = [];

      var self = this;

      this.el.querySelectorAll("ul[strikethrough-list]").forEach(function (list) {
        self.strikethroughLists.push(new StrikeThroughList(list));
      });
      this.el.querySelectorAll("video[autoplayonscroll]").forEach(function (v) {
        self.videoElements.push(new VideoElement(v));
      });
      this.el.querySelectorAll("[carousel]").forEach(function (c) {
        self.carousels.push(new Carousel(c));
      });
      this.el.querySelectorAll("[show-at]").forEach(function (s) {
        self.showAtElements.push(new ShowAtElement(s));
      });
      this.el.querySelectorAll("[fade-in]").forEach(function (f) {
        self.fadeInElements.push(new FadeInElement(f));
      });

      this.onUpdate();
    }
    onUpdate() {
      this.videoElements.forEach(function (v) { v.onUpdate(); });
      this.showAtElements.forEach(function (s) { s.onUpdate(); });
      this.carousels.forEach(function (c) { c.onUpdate(); });
      this.strikethroughLists.forEach(function (l) { l.onUpdate(); });
      this.fadeInElements.forEach(function (f) { f.onUpdate(); });
    }
  }

  function init() {
    var container = document.querySelector(".echo-page");
    if (!container) return;

    var sections = [];
    var parallaxElements = [];

    container.querySelectorAll("section").forEach(function (el) {
      sections.push(new Section(el));
    });

    container.querySelectorAll("[parallax]").forEach(function (el) {
      parallaxElements.push(new ParallaxElement(el));
    });

    window.addEventListener("scroll", function () {
      sections.forEach(function (s) { s.onUpdate(); });
      parallaxElements.forEach(function (p) { p.onUpdate(); });
    });

    sections.forEach(function (s) { s.onUpdate(); });
    parallaxElements.forEach(function (p) { p.onUpdate(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
